if (!customElements.get('mqn-testimonials')) {
  customElements.define('mqn-testimonials', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller=new AbortController();
      const options= {
        signal:this.controller.signal
      }
      ;
      const track=this.querySelector('.mqnt-track'), slides=[...this.querySelectorAll('.mqnt-slide')], dots=[...this.querySelectorAll('[data-dot]')];
      if(!slides.length)return;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      const pause=this.querySelector('[data-pause]');
      let current=0, visible=false, hovering=false, touching=false, focused=false, editorSelected=false;
      let manuallyPaused=reduced.matches;
      const playing=()=>[...this.querySelectorAll('video')].some(v=>!v.paused&&!v.ended);
      const buttonState=()=> {
        if(pause) {
          pause.textContent=manuallyPaused?'Reanudar':'Pausar';
          pause.setAttribute('aria-pressed',String(manuallyPaused));
          pause.setAttribute('aria-label',manuallyPaused?'Reanudar rotación automática':'Pausar rotación automática');
        }
      }
      ;
      const schedule=()=> {
        clearTimeout(this.timer);
        if(this.dataset.autoplay!=='true'||slides.length<2||!visible||document.hidden||hovering||touching||focused||editorSelected||manuallyPaused||playing())return;
        this.timer=setTimeout(()=>go(current+1),Math.max(3000,Number(this.dataset.delay)||6000));
      }
      ;
      const update=()=> {
        let nearest=0,distance=Infinity;
        slides.forEach((slide,index)=> {
          const delta=Math.abs(slide.getBoundingClientRect().left-track.getBoundingClientRect().left);
          if(delta<distance) {
            distance=delta;
            nearest=index;
          }
        }
        );
        current=nearest;
        dots.forEach((dot,index)=>dot.setAttribute('aria-current',String(index===current)));
        slides.forEach((slide,index)=> {
          if(index!==current)slide.querySelectorAll('video').forEach(v=>v.pause());
        }
        );
        schedule();
      }
      ;
      const go=(index)=> {
        const slide=slides[(index+slides.length)%slides.length];
        track.scrollTo( {
          left:track.scrollLeft+slide.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:reduced.matches?'instant':'smooth'
        }
        );
        schedule();
      }
      ;
      this.querySelector('[data-prev]')?.addEventListener('click',()=>go(current-1),options);
      this.querySelector('[data-next]')?.addEventListener('click',()=>go(current+1),options);
      dots.forEach((dot,index)=>dot.addEventListener('click',()=>go(index),options));
      pause?.addEventListener('click',()=> {
        manuallyPaused=!manuallyPaused;
        buttonState();
        schedule();
      }
      ,options);
      track.addEventListener('scroll',()=> {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        this.frame=requestAnimationFrame(update);
      }
      ,options);
      this.addEventListener('pointerenter',event=> {
        if(event.pointerType==='mouse') {
          hovering=true;
          schedule();
        }
      }
      ,options);
      this.addEventListener('pointerleave',()=> {
        hovering=false;
        schedule();
      }
      ,options);
      this.addEventListener('pointerdown',()=> {
        touching=true;
        schedule();
      }
      ,options);
      window.addEventListener('pointerup',()=> {
        touching=false;
        schedule();
      }
      ,options);
      window.addEventListener('pointercancel',()=> {
        touching=false;
        schedule();
      }
      ,options);
      this.addEventListener('focusin',event=> {
        focused=true;
        const slide=event.target.closest('.mqnt-slide');
        if(slide)go(slides.indexOf(slide));
        schedule();
      }
      ,options);
      this.addEventListener('focusout',event=> {
        focused=this.contains(event.relatedTarget);
        schedule();
      }
      ,options);
      this.addEventListener('play',event=> {
        this.querySelectorAll('video').forEach(v=> {
          if(v!==event.target)v.pause();
        }
        );
        schedule();
      }
      , {
        ...options,capture:true
      }
      );
      ['pause','ended'].forEach(type=>this.addEventListener(type,schedule, {
        ...options,capture:true
      }
      ));
      document.addEventListener('visibilitychange',schedule,options);
      reduced.addEventListener('change',()=> {
        if(reduced.matches)manuallyPaused=true;
        buttonState();
        schedule();
      }
      ,options);
      document.addEventListener('shopify:block:select',event=> {
        const index=slides.findIndex(slide=>slide.dataset.block===event.detail.blockId);
        if(index>=0) {
          editorSelected=true;
          go(index);
        }
      }
      ,options);
      document.addEventListener('shopify:block:deselect',event=> {
        if(slides.some(slide=>slide.dataset.block===event.detail.blockId)) {
          editorSelected=false;
          schedule();
        }
      }
      ,options);
      this.observer=new IntersectionObserver(entries=> {
        visible=entries[0].isIntersecting;
        if(!visible)this.querySelectorAll('video').forEach(v=>v.pause());
        schedule();
      }
      , {
        threshold:.2
      }
      );
      this.observer.observe(this);
      buttonState();
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
    }
  }
  );
}
